import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { documentToHtmlString } from '@contentful/rich-text-html-renderer';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { IconName } from '@fortawesome/free-solid-svg-icons';
import { AssetFile } from 'contentful';
import { TypeSectionProgramFields } from '../../../models/contentful-content-types/section-program';
import { TileComponent } from '../tile/tile.component';
import { ScrollSectionDirective } from '../../utils/directives/scroll-section.directive';

@Component({
  imports: [CommonModule, FontAwesomeModule, TileComponent, ScrollSectionDirective],
    selector: 'jnguyen-section-program',
    templateUrl: './section-program.component.html',
    styleUrls: ['./section-program.component.scss'],
})
export class SectionProgramComponent {
  @Input() data: TypeSectionProgramFields;
  documentToHtmlString = documentToHtmlString;

  getIcon(icon: IconName, iconClass: string): string[] {
    return [iconClass, icon];
  }

   getImageUrl(url: string | AssetFile) {
    if (typeof url === "string") {
      const cutUrl = url.replace(/\/\/images\.ctfassets\.net\//, "");
      return `${cutUrl}`;
    }
  }
}
